import { StoreAction } from "../../@core/constants/action";

const initialState = {
  customerDataActive: [],
  customerFilter: {},
};

const customerReducer = (state = initialState, action) => {
  switch (action.type) {
    case StoreAction.GET_CUSTOMER_DATA_ACTIVE:
      return {
        ...state,
        customerDataActive: action.payload,
      };
    case StoreAction.SET_CUSTOMER_FILTER:
      return {
        ...state,
        customerFilter: action.payload,
      };
    default:
      return state;
  }
};

export default customerReducer;
